import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { ICapacityEvaluationRepository } from '@/api/fe-api/domain/repositories/capacity-evaluation.repository';

export namespace GetJobDetails {
  export const key = (input: Input) => [
    'capacity-evaluation',
    'get-job-details',
    ...Object.entries(input).flatMap(([key, value]) => [key, value]),
  ];

  export type Params = { refetchInterval?: number };
  export type Input = ICapacityEvaluationRepository.GetByIdInput;
  export type Output = ICapacityEvaluationRepository.GetByIdOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () => repositories.capacityEvaluation.getById(input),
    });
  }
}
